<div class="d-flex justify-content-between align-items-center mb-3">
  <div class="col-9">
    <h1>{{ title }}</h1>
  </div>
  <div class="col-3 col-md-auto">
    <app-action-buttons />
  </div>
</div>
